import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { EstablishmentFormComponent, EstablishmentFormValues } from '../../form/establishment-form.component';
import { FormModalDialogComponent } from '../../../common/form-modal-dialog/form-modal-dialog.component';
import { EstablishmentService } from '../../../../services/establishments/establishment.service';
import { Subject, takeUntil } from 'rxjs';
import { Establishment } from '../../../../../../../graphql/generated';

@Component({
    selector: 'app-edit-establishment',
    templateUrl: './edit-establishment.component.html',
    styleUrl: './edit-establishment.component.scss',
    imports: [FormModalDialogComponent, EstablishmentFormComponent],
})
export class EditEstablishmentComponent implements OnDestroy {
    protected readonly destroy$ = new Subject<void>();

    @ViewChild('modal')
    modalRef: FormModalDialogComponent;

    @Input({ required: true })
    establishment: Establishment;

    constructor(
        private readonly establishmentService: EstablishmentService,
    ) {
    }

    updateEstablishment(values: EstablishmentFormValues) {
        const currentParentId = this.establishment.parentEstablishmentId;
        const newParentId = values.parentEstablishmentId;

        // Build billing info object if any billing fields are filled
        const billingInfo = this.hasBillingInfo(values) ? {
            companyName: values.billingCompanyName || undefined,
            address: values.billingAddress || undefined,
            postalCode: values.billingPostalCode || undefined,
            city: values.billingCity || undefined,
            country: values.billingCountry || undefined,
            kvkNumber: values.billingKvkNumber || undefined,
            vatNumber: values.billingVatNumber || undefined,
            iban: values.billingIban || undefined,
            phone: values.billingPhone || undefined,
            email: values.billingEmail || undefined,
        } : undefined;

        this.establishmentService
            .updateEstablishment({
                establishmentId: this.establishment.id,
                name: values.name,
                commissionPercentage: values.commissionPercentage ? Number(values.commissionPercentage) : undefined,
                parentEstablishmentId: newParentId || undefined,
                clearParentEstablishment: currentParentId && !newParentId ? true : undefined,
                billingInfo,
            })
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.modalRef.close());
    }

    private hasBillingInfo(values: EstablishmentFormValues): boolean {
        return !!(
            values.billingCompanyName ||
            values.billingAddress ||
            values.billingPostalCode ||
            values.billingCity ||
            values.billingKvkNumber ||
            values.billingVatNumber ||
            values.billingIban ||
            values.billingPhone ||
            values.billingEmail
        );
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
